import { render } from "./ApprovedNotificationTable.vue?vue&type=template&id=68d99200&ts=true"
import script from "./ApprovedNotificationTable.vue?vue&type=script&lang=ts"
export * from "./ApprovedNotificationTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__